const getters = {
  // isMobile: (state) => navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i),
  isMobile: () => document.body.clientWidth < 767,
  // isPad: (state) => document.body.clientWidth > 767 && document.body.clientWidth < 1199,
  isPc: () => document.body.clientWidth > 1199,
  is2k: () => document.body.clientWidth > 2020,
  visitedViews: (state) => state.tagsView.visitedViews,
  cachedViews: (state) => state.tagsView.cachedViews,
  // errorLogs: (state) => state.errorLog.logs,
  user: (state) => state.user,
  userId: (state) => state.user.id,
  userStoreId: (state) => state.user.store_id,
  defaultStoreId: (state) => state.user.isHeadOffice ? 0 : state.user.store_id,
  userRole: (state) => state.user.role,
  userExpiryTime: (state) => state.user.expiry_time,
  userToken: (state) => state.user.token,
  userAvatar: (state) => state.user.avatar,
  userNickname: (state) => state.user.name,
  isAdministrator: (state) => state.user.isAdministrator,
  isManager: (state) => state.user.isManager,
  isReceptionist: (state) => state.user.isReceptionist,
  isAdministratorOrManager: (state) => state.user.isAdministrator || state.user.isManager,
  isManagerOrReceptionist: (state) => state.user.isManager || state.user.isReceptionist,
  isGenericStore: (state) => state.user.isGenericStore,
  isHeadOffice: (state) => !!state.user.isHeadOffice,
};
export default getters;
